import BCButtonDropdown from "../ui/BCButtonDropdown";

interface IBWActionsButton {
    addOptionAction: any;
}

const BWActionsButton = ({...props}: IBWActionsButton) => {
    const handleOptionsChange = async (index) => {
        if (BPActionsOptions[index].value === "Add") {
            props.addOptionAction();
        }
    };

    const BPActionsOptions = [
        { key: "Add", icon: "plus", text: "Add", value: "Add" }
    ];

    return (
        <BCButtonDropdown
            buttonClass="borrower-dropdown-button"
            buttonGroupText="Actions"
            buttonGroupClass="bc-button-group prescreen-button-group"
            handleOptionClick={handleOptionsChange}
            options={BPActionsOptions}
            dropdownMenuClass="actions-button-dropdown"
        />
    );
};

export default BWActionsButton;